import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Table, Button, Drawer,
} from 'antd';
import { EditOutlined } from '@ant-design/icons';
import OfferActions from '@Actions/offerActions';
import SellerActions from '@Actions/sellerActions';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import Helpers from '@Apis/helpers';
import OfferForm from '@Components/Common/Form/OfferForm';
import './style.scss';
import HideValue from '../RestrictedAccess/HideValue';
import RestrictedAccessMessage from '../RestrictedAccess/RestrictedAccessMessage';

/**
 * SelectOffer component
 *
 * @param file
 */
class SelectOffer extends Component {
  /**
   * Constructor
   *
   * @param props
   */
  constructor(props) {
    super(props);
    const { priceMasking } = props;
    const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;
    this.state = {
      tableColumns: [
        {
          title: 'Vendor Id',
          render: (text, record) => `${record?.seller_info?.seller_id}`,
        },
        {
          title: 'Vendor Name',
          render: (text, record) => {
            const { history } = this.props;
            const { handleSellerSelection, toggleOfferModal, currentLine } = this.props;
            return (
              <React.Fragment>
                {' '}
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
                >
                  <div
                    style={{
                      color: '#2D7DF7', fontWeight: '600', fontSize: '12px', cursor: 'pointer', marginRight: '5px',
                    }}
                    onClick={() => history.push(`/vendors/view/${record?.seller_info?.seller_id}`)}
                  >
                    {record?.seller_info?.seller_name || ' - '}
                  </div>
                  {record?.is_default && (
                    <div className="status-tag">
                      Default
                    </div>
                  )}
                  &nbsp;
                  {record?.is_preferred_supplier && (
                    <div
                      className="status-tag"
                      style={{
                        backgroundColor: 'orange',
                      }}
                    >
                      Preferred
                    </div>
                  )}
                </div>
                <div>
                  {record?.seller_info?.city || ''}
                </div>
              </React.Fragment>

            );
          },
        },
        {
          title: 'MOQ',
          dataIndex: 'moq',
        },
        {
          title: 'Offer Price',
          dataIndex: 'minimum_variant_price',
          render: (text, record) => ((isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view offer price"}/> : this.props.MONEY(record.offer_price)),
        },
        {
          title: '',
          dataIndex: '',
          render: (text, record) => {
            const { handleSellerSelection, toggleOfferModal, currentLine, user } = this.props;
            // Initialize two empty arrays to hold the MO and SO line ids separately
            let moLineIds = [];
            let soLineIds = [];
            // Check if 'lines' exists and is an array with at least one item
            if (currentLine?.lines && Array.isArray(currentLine.lines) && currentLine.lines.length > 0) {
              // Extract MO line ids
              moLineIds = currentLine.lines.reduce((acc, line) => {
                if (line.mo_line_id) acc.push(line.mo_line_id);
                return acc;
              }, []);
              // Extract SO line ids
              soLineIds = currentLine.lines.reduce((acc, line) => {
                if (line.order_line_id) acc.push(line.order_line_id);
                return acc;
              }, []);
            }
            const selectedSoIds = currentLine?.order_line_id || soLineIds;
            const selectedMoIds = currentLine?.mo_line_id || moLineIds;

            return (
              <div style={{ display: 'flex' }}>
                <Button
                  type="primary"
                  shape="round"
                  size="small"
                  onClick={() => {
                    handleSellerSelection(currentLine?.tenantProductId, record, selectedSoIds, selectedMoIds, currentLine);
                    toggleOfferModal();
                  }}
                  disabled={currentLine?.sku_offer_id === record?.sku_offer_id}
                >
                  Select
                </Button>
                &nbsp;
                {Helpers.getPermission(Helpers.permissionEntities.VENDOR_PRICE, Helpers.permissionTypes.UPDATE, user)
                  && (
                    <div
                      className="roundIconButton"
                      onClick={() => {
                        this.setState({
                          isEditing: true,
                          addOfferModal: true,
                          selectedOffer: record,
                        });
                      }}
                    >
                      <EditOutlined />
                    </div>
                  )}
              </div>
            );
          },
        },
      ],
      isEditing: false,
    };
  }

  /**
   *
   */
  componentDidMount() {
    const { getSellers, user, tenantId } = this.props;
    getSellers('', tenantId || user?.tenant_info?.tenant_id, 1, 10);
  }

  /**
   *
   * @param sellers
   * @return {*[]}
   */
  getSellers = (sellers) => {
    const updateSellers = [];
    if (sellers) {
      for (let i = 0; i < sellers.length; i++) {
        updateSellers.push({
          ...sellers[i],
          key: i,
        });
      }
    }
    return updateSellers;
  }

  /**
   *
   * @return {*}
   */
  render() {
    const {
      tableColumns, isEditing, addOfferModal, selectedOffer,
    } = this.state;
    const {
      selectOfferVisible, toggleOfferModal, offers, getOffersLoading, currentLine, tenantId,
      getOffers, newCallback, priceMasking, user,
    } = this.props;

    const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;
    return (
      <Drawer
        open={selectOfferVisible}
        onClose={() => toggleOfferModal()}
        destroyOnClose
        width="720px"
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '675px' }}>
            <H3Text text="Select Vendor Price" className="custom-drawer__title" style={{ width: '640px' }} />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => toggleOfferModal()} />
          </div>
        </div>
        <H3Text text={currentLine?.productName} className="select-offer__product-name" />
        <div className="generic-table-container">
          <Table
            bordered
            loading={getOffersLoading}
            showHeader
            size="small"
            scroll="scroll"
            tableLayout="unset"
            top="none"
            bottom="bottomRight"
            columns={tableColumns}
            dataSource={offers ? this.getSellers(offers.offers) : []}
            title={() => (
              <div className="select-offer__table-header">
                {`${(offers && offers.count) ? offers.count : '0'} Vendor Price(s) Available`}
                {Helpers.getPermission(Helpers.permissionEntities.VENDOR_PRICE, Helpers.permissionTypes.CREATE, user) && (
                  <div className="select-offer__table-header__left">
                    <H3Button
                      buttonType={defaultButtonTypes.BLUE_ROUNDED}
                      text="+ New Vendor Price"
                      onClick={() => this.setState({ addOfferModal: true })}
                      customClass="select-offer__add-button"
                      disabled={isDataMaskingPolicyEnable && isHideCostPrice}
                    />
                  </div>
                )}
              </div>
            )}
            rowClassName={(record) => (!record.is_active ? 'inactive_record' : '')}
          />
        </div>
        <Drawer
          open={addOfferModal}
          destroyOnClose
          footer={null}
          width="360px"
          onClose={
            () => this.setState({
              addOfferModal: false,
              isEditing: false,
            })
          }
        >
          <OfferForm
            currentLine={currentLine}
            selectedOffer={selectedOffer}
            callback={() => {
              this.setState({
                addOfferModal: false,
                isEditing: false,
              });
              if (newCallback) newCallback();
              getOffers(currentLine?.tenantProductId, '');
            }}
            isEditing={isEditing}
            toggleNewOfferModal={() => this.setState({ addOfferModal: false })}
            tenantId={tenantId}
          />
        </Drawer>

        <div className="custom-drawer__footer">
          <div className="ant-col-md-6">
            {isDataMaskingPolicyEnable && isHideCostPrice && <RestrictedAccessMessage message={"You don't have access to view/edit/add offer price"} />}
          </div>
        </div>
      </Drawer>
    );
  }
}

const mapStateToProps = ({ OfferReducers, SellerReducers, UserReducers }) => ({
  getOffersLoading: OfferReducers.getOffersLoading,
  offers: OfferReducers.offers,
  sellers: SellerReducers.sellers,
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  priceMasking: UserReducers.priceMasking,
});

const mapDispatchToProps = (dispatch) => ({
  getOffers: (tenantProductId, tenantSellerId) => dispatch(OfferActions.getOffers(tenantProductId, tenantSellerId)),
  getSellers: (keyword, tenantId, page, limit) => dispatch(SellerActions.getSellers(keyword, tenantId, page, limit)),
});

SelectOffer.propTypes = {
  getOffers: PropTypes.func,
  getOffersLoading: PropTypes.bool,
  offers: PropTypes.any,
  selectOfferVisible: PropTypes.bool,
  toggleOfferModal: PropTypes.func,
  getSellers: PropTypes.func,
  user: PropTypes.any,
  currentLine: PropTypes.any,
  handleSellerSelection: PropTypes.any,
  tenantId: PropTypes.any,
  MONEY: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SelectOffer));
